import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import {
  PageOfAnyRecordsSchema,
  type PageOfAnyRecordsType,
} from '../../common/utils';
import { OutputDataUrl } from './OutputDataUrl';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { PageRequestParams } from '../../common/queryClient';

export type TestCalculationOutputDataParams = PageRequestParams & {
  dagRunId: string;
  filterParams?: Record<string, any>;
};

export const getTestCalculationOutputData = (
  params: TestCalculationOutputDataParams,
) =>
  apiClient
    .get<PageOfAnyRecordsType>(
      expand(OutputDataUrl.TEST_CALCULATIONS_OUTPUT_DATA, params),
    )
    .then((response) => PageOfAnyRecordsSchema.parse(response.data));

export const useTestCalculateOutputDataQuery = createApiQueryHook(
  ['outputTestCalculationOutputData'],
  getTestCalculationOutputData,
);
